export default "__VITE_PUBLIC_ASSET__252af34d__"